import { useQuery } from '@tanstack/react-query';
import { loadContentFromDropboxStore } from '@/postulation_form/services/api';

export const useDropboxFileFetch = ({ dropboxFile, onSuccess, onError }) => {
  return useQuery({
    queryKey: ['loadContentFromDropbox', dropboxFile.url],
    queryFn: async () => {
      if (!dropboxFile.url) {
        return null;
      }
      return loadContentFromDropboxStore(dropboxFile.url);
    },
    enabled: dropboxFile.url !== null,
    retry: 0,
    staleTime: Infinity,
    onError: (error) => {
      console.error('Dropbox fetch error:', error);
      onError?.(error);
    },
    onSuccess: (response) => {
      if (!response) return;

      const fileContent = new File([response], dropboxFile.name);
      onSuccess({
        fileContent,
        fileType: dropboxFile.fileType,
        fileName: dropboxFile.name
      });
    }
  });
};
